import actions from 'react/api/actions';
import { fromJS } from 'immutable';

const initialState = fromJS({
  isOpen: false,
});

export default (state = initialState, action) => {

  if (actions.modal.actions.changeIsOpen === action.type) {
    return state.mergeIn(['isOpen'], action.payload);
  }

  return state;
};
